<template>
    <div>
        <v-divider></v-divider>
        <div class="text-h6 font-weight-bold my-2">Les groupes existants <v-chip color="primary-dark" density="compact"
                variant="elevated" elevation="0">{{ list_liens.length }}</v-chip></div>
        <v-table density="compact" v-if="list_liens.length > 0">
            <thead>
                <tr>
                    <th class="text-left">Actions</th>
                    <th class="text-left">Statut</th>
                    <th class="text-left">Nom groupe</th>
                    <th class="text-left">Limitation</th>
                    <th class="text-left">Utilisation</th>

                </tr>
            </thead>
            <tbody>
                <tr v-for="item in list_liens" :key="item.id">
                    <td>
                        <v-btn @click="navigateToSuivi(item.token)" size="small" class="mr-1" color="darkblue"
                            variant="elevated" elevation="0">
                            <v-icon icon="mdi-chart-timeline-variant"></v-icon>
                            Suivi
                        </v-btn>
                        <v-btn @click="navigateToEdit(item.token)" size="small" color="primary-dark" variant="elevated"
                            elevation="0">
                            <v-icon icon="mdi-pencil"></v-icon>

                        </v-btn>
                    </td>
                    <td>
                        <v-chip :color="getStatutColor(getStatutLabel(item))" density="compact" variant="elevated"
                            elevation="0">{{ getStatutLabel(item) }} {{ info_paiement(item) }}</v-chip>
                    </td>
                    <td>{{ item.nom }}</td>
                    <td>{{ item.max_inscrits == 0 ? 'Aucune limite' : item.max_inscrits + ' inscriptions' }}</td>
                    <td>{{ item.nb_inscrits }} inscription<span v-if="item.nb_inscrits > 1">s</span> (sur {{
                        item.nb_commandes }} commande<span v-if="item.nb_commandes > 1">s</span>)</td>

                </tr>
            </tbody>
        </v-table>

        <v-alert v-else variant="tonal" color="info">Aucun lien de groupe pour ce module</v-alert>

    </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import AdminService from "@/services/admin.service";
export default {
    data() {
        return {
            list_liens: [],
        };
    },
    computed: {
        ...mapStores(useMainStore),

    },
    methods: {
        navigateToSuivi(token) {
            this.$router.push({ name: 'SuiviLienGroupe', params: { base_module: this.mainStore.module.base, token: token } });
        },
        navigateToEdit(token) {
            this.$router.push({ name: 'EditLienGroupe', params: { base_module: this.mainStore.module.base, token: token } });
        },
        info_paiement(item) {
            let info = '';
            if (item.statut_paiement !== 'PAID') return '';

            if (item.total_responsable_with_tax > 0) info += item.total_responsable_with_tax + '€';
            if (item.type_paiement && item.type_paiement !== 'aucun') info += ' par ' + item.type_paiement;
            if (info.length > 0) {
                info = '(' + info + ')';
            }
            return info;
        },
        getStatutLabel(item) {
            if (item.statut_paiement === 'PAID' && item.total_responsable == 0) return 'Cloturé';
            if (item.statut_paiement === 'PAID' && item.total_responsable > 0) return 'Payé';
            if (item.statut_paiement === 'UNPAID' && item.total_responsable > 0) return 'En attente de paiement';
            if (item.disable === '1') return 'Cloturé';
            return 'Actif';
        },
        getStatutColor(statut) {
            const colors = {
                'Actif': 'green',
                'En attente de paiement': 'primary-dark',
                'Payé': 'secondary-dark',
                'Cloturé': 'secondary-dark',
            };
            return colors[statut] || 'grey';
        },
        async loadLiens() {
            const request = await AdminService.getLiensGroupe(this.mainStore.module.id);
            if (request) {
                this.list_liens = request;
                //sort by nom asc
                this.list_liens.sort((a, b) => a.nom.localeCompare(b.nom));
            }
        }

    },

    async created() {
        await this.loadLiens();
    },

}
</script>

<style lang="scss" scoped></style>
